import Cookies from 'js-cookie';

const cookies = {
  locale: 'pa-locale',
  token: 'pa-v4-token',
  merchantID: 'pa-merchant-id',
  originalUrl: 'pa-original-url',
  serverDataFetchingDisabled: '__server-data-fetching-disabled',
  integrationType: 'integration-type',
  hardCopyLocked: 'pa-hard-copy-locked',
  utmCampaign: 'utm_campaign',
  mfaRemembered: 'xl-40db2ea4-5d42-11e6-a3ff-005056a0e04a-security-challenge-id',
  postIntegrationSurvey: 'post-integration-survey',
  postIntegrationSurveyDisabled: 'post-integration-survey-disabled',
  postIntegrationSurveyProduct: 'post-integration-survey-product',
  quarterly_survey: 'quarterly_survey',
  endToEndAuthToken: 'end-to-end-auth-token',
  support_survey: 'support_survey',
  sidebar_funding: 'sidebar-funding'
};

const specialCookies = {assignToAm: 'pa-assign-card-id'};

class UserCookie {
  constructor() {
    this.cookies = Object.values(cookies);
    this.specialCookies = Object.values(specialCookies);
  }

  static getInstance() {
    if (UserCookie.instance) {
      return UserCookie.instance;
    }

    UserCookie.instance = new UserCookie();
    return UserCookie.instance;
  }

  setPolicy(allTypesAllowed) {
    this.allTypesAllowed = allTypesAllowed;
  }

  set(name, value, options) {
    if (
      this.allTypesAllowed ||
      this.cookies.includes(name) ||
      this.specialCookies.some(item => name.includes(item))
    ) {
      Cookies.set(name, value, options);
    }
  }

  get(name) {
    return Cookies.get(name);
  }

  remove(name, options = null) {
    options ? Cookies.remove(name, options) : Cookies.remove(name);
  }
}

export const cookie = UserCookie.getInstance();
